module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-5-512.afb53274715bc9b7.jpg"+" 512w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-5-512.afb53274715bc9b7.jpg",width: 512,height: 341}],
        src: "https://static.sniffspot.com/packs/img/bp-5-512.afb53274715bc9b7.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-5-512.afb53274715bc9b7.jpg"},
        
        width: 512,
        height: 341
      }